import clsx from "clsx"
import classes from "./ButtonSkip.module.scss"
import { useDispatch, useSelector } from "react-redux";
import { skipQuestion } from "@educaplay/store/slices/gameSlice";
import { SkipIcon } from "../Icons";
import { isUnansweredAnswer } from "@educaplay/store/utils/functions";





export default function ButtonSkip(props) {

    
    const {handleHover, passFinalQuestion, className} = props;
    const dispatch = useDispatch();
    const questions = useSelector(state => state.game.questions);
    const currentIndex = useSelector(state => state.game.currentIndex);
    const isFinalQuestion = currentIndex === questions.length - 1;
    const navigationUnansweredHandler = () => {
        dispatch(skipQuestion());
    }
    const numUnansweredQuestions = questions.length - questions.filter(question => (
        question.answer !== null &&
        (typeof question.answer === "object" && question.answer.answer !== null && question.answer?.answer !== "") &&
        (Array.isArray(question.answer?.answer) ? question.answer?.answer.length > 0 : question.answer?.answer !== ""))).length;


    const areUnansweredQuestions = (questions) => {
        return questions.some(question => isUnansweredAnswer(question.answer))
    }

    return(
        <button
            className={clsx(className,classes.buttonPager, classes.buttonPager__skip)}
            type="button"
            onClick={navigationUnansweredHandler}
            onMouseEnter={handleHover}
            disabled={(!passFinalQuestion) || !areUnansweredQuestions(questions) || (isFinalQuestion && !areUnansweredQuestions(questions.slice(0, -1)))}
        >
            <span className={classes.buttonPager__icon}>
                <SkipIcon/>
            </span>
            <div className={classes.buttonPager__text}>
                {numUnansweredQuestions}
            </div>
        </button>
    );
}